import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="border-y border-line bg-navy-950 text-center text-white" aria-label="Limited time offer" data-id="element-201" data-mp="2sk46nkhn1yb1">
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-202" data-mp="36c26t5tdgjv2">
        <p className="inline-flex items-center gap-2 text-sm font-semibold text-gold" data-id="element-203" data-mp="31iz8kkdngm8j">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-204" data-mp="3g7lz7i8q90f2" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-205" data-mp="3b9txjwia5zxo" />
        <p className="mt-7 font-medium text-silver" data-id="element-206" data-mp="3b8sm3qxcrbff">After that the price increases and never drops again.</p>
      </div>
    </section>;
}